module.exports = __webpack_public_path__ + "static/media/no-credits-mobile@3x.152c6b2f.png";